import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import pathname from '../../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import OperationAreaWidget from '../../../widgets/projectProposal/operationArea/OperationAreaWidget'
import ProjectTagetWidget from '../../../widgets/projectProposal/projectTarget/ProjectTagetWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID, TEMP_FORM_ID } from '../../../constants/constants'
import { getFormTargetGroupOperationArea } from '../../../redux/actions/subProjectProposal'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import { getSettingFormTargetGroupOperationAreaPreView } from '../../../redux/actions/subProjectFormSetting'

export default function ProjectTargetOperationArea(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)
  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    // setSchema(mockSchema)
    if (mode == 'preView' && formId) {
      handleGetSchemaPreView()
    } else if (subProjectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //let _schema = mockSchema //await getProjectName(proposalId)
      let _schema = await getFormTargetGroupOperationArea(subProjectId)
      setSchema(_schema)
      setIsEditWidget({
        targetGroup: _schema.forms?.targetGroup?.id ? false : true,
        operationArea: _schema.forms?.operationArea?.id ? false : true,
      })

      setShowEditAll(
        !_schema.forms?.targetGroup?.disabled && !_schema.forms?.operationArea?.disabled
      )
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPreView = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getSettingFormTargetGroupOperationAreaPreView(formId)

      setSchema(_schema)
      setIsEditWidget({
        targetGroup: true,
        operationArea: true,
      })

      setShowEditAll(false)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProject mode={mode}>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

          {showEditAll && (
            <>
              <BtnEditAll
                onClickEditAll={getIsEditAll(isEditWidget)}
                routing={schema.buttonRoute}
                setOnClickEditAll={(_isEdit) =>
                  setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)
                }
                editWidget={isEditWidget}
                forms={schema?.forms}
              />
            </>
          )}

          {schema?.forms?.targetGroup && (
            <ProjectTagetWidget
              showCommandButton={!schema.forms.targetGroup.disabled}
              schema={schema.forms.targetGroup}
              isEdit={isEditWidget.targetGroup}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('targetGroup', _isEdit, setIsEditWidget)
              }
            />
          )}

          {schema?.forms?.operationArea && (
            <OperationAreaWidget
              showCommandButton={!schema.forms.operationArea.disabled}
              schema={schema.forms.operationArea}
              isEdit={isEditWidget.operationArea}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('operationArea', _isEdit, setIsEditWidget)
              }
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
